// See bootstrap values: (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)
export const smallScreen = (limit :string): boolean => window.matchMedia(`(${limit}-width: 576px)`).matches;
export const largeScreen = (limit :string): boolean => window.matchMedia(`(${limit}-width: 992px)`).matches;

